import {
  Box,
  FormModal,
  FormSectionTitle,
  SpinnerButton,
  TextField,
  ValueAutocompleteField,
} from '@forgeglobal/design-framework'
import { Field, Form, FormRenderProps } from 'react-final-form'
import { MutationResult } from 'react-apollo'
import {
  UpdateIssuerHeaderMutationVariables,
  useIssuerHeaderQuery,
  useUpdateIssuerHeaderMutation,
} from 'graphql/bindings/AdminBindings'
import { countryOptions, usStateOptions } from 'util/LocationUtils'
import React from 'react'
import omit from 'lodash/omit'

interface FormShape {
  id: string
  organizationName: string
  country: string
  state: string
  city: string
  notes: string
  mutationResult: MutationResult
}

const HeaderForm: React.FC<FormRenderProps<FormShape>> = ({ handleSubmit, form, values, valid }) => {
  const mutateInProgress = values.mutationResult.called
  return (
    <form onSubmit={handleSubmit}>
      <Field name="organizationName" label="Name" component={TextField} fullWidth />
      <FormSectionTitle>Location of headquarters</FormSectionTitle>
      <ValueAutocompleteField name="country" label="Country" options={countryOptions} />
      {values.country === 'US' && <ValueAutocompleteField name="state" label="State" options={usStateOptions} />}
      {values.country && <Field name="city" component={TextField} label="City" fullWidth />}
      <Field name="notes" component={TextField} label="Additional information" fullWidth multiline />
      <Box mt={2}>
        <SpinnerButton
          variant="contained"
          color="primary"
          type="submit"
          fullWidth
          loading={mutateInProgress}
          caption="Save"
        />
      </Box>
    </form>
  )
}

export const IssuerHeaderModal: React.FC<{ hideModal: () => void; accountId: string }> = ({ hideModal, accountId }) => {
  const { data } = useIssuerHeaderQuery({ variables: { issuerId: accountId } })
  const [mutate, mutateResult] = useUpdateIssuerHeaderMutation({
    onCompleted: hideModal,
  })
  const issuer = data?.account
  const onSubmit = (values: any) => {
    mutate({ variables: { form: omit(values, ['type', 'mutationResult']) } as UpdateIssuerHeaderMutationVariables })
  }

  const initialValues = {
    id: issuer?.id,
    organizationName: issuer?.name ?? '',
    country: issuer?.country ?? '',
    state: issuer?.state ?? '',
    city: issuer?.city ?? '',
    notes: issuer?.notes ?? '',
    mutationResult: mutateResult,
  }

  return (
    <FormModal open hideModal={hideModal} title="Edit: Issuer">
      <Form component={HeaderForm} onSubmit={onSubmit} initialValues={initialValues} />
    </FormModal>
  )
}
